const RESOURCE_KEY = {
  WORKFLOW_CORE: 'crm:workflow_core'
};

export default RESOURCE_KEY;
